module.exports = __webpack_public_path__ + "img/cai3.e5d72472.png";